
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.864 4.136a.75.75 0 0 1 0 1.06l-6.667 6.668a.75.75 0 0 1-1.06 0L2.802 8.53a.75.75 0 0 1 1.06-1.06l2.804 2.803 6.136-6.137a.75.75 0 0 1 1.06 0Z","fill":"#302936"}})])
          )
        }
      }
    